export type IDiscountDetailsResources = typeof DiscountDetailsResources;

export const DiscountDetailsResources = {
    goToOfferButton: "Idź do okazji",
};
